export const GET_ALL_PRODUCT_CHANNELS = "GET_ALL_PRODUCT_CHANNELS"
export const GET_ALL_PRODUCT_CHANNELS_RESPONSE_SUCCESS =
  "GET_ALL_PRODUCT_CHANNELS_RESPONSE_SUCCESS"
